<template>
  <v-dialog v-model="openTest" max-width="44rem">
    <v-card>
      <v-card-title class="headline grey lighten-2"
        >Test Instructions</v-card-title
      >
      <v-card-text>
        <v-subheader>General Instructions</v-subheader>
        <v-list>
          <v-list-item>
            1. The test duration is
            <span
              class="mr-1 ml-1"
              style="font-weight: 700"
              v-if="testComp.duration != null"
              >{{ testComp.duration }}</span
            ><span class="mr-1 ml-1" style="font-weight: 700" v-else>5</span
            >minutes. The test will automatically submit when the time ends.
          </v-list-item>
          <v-list-item>
            2. Do not refresh the page or use the back button. Doing so will
            result in automatic submission of the test.
          </v-list-item>
          <v-list-item>
            3. Ensure you have a stable internet connection throughout the test.
          </v-list-item>
          <v-list-item>
            3. Navigation between the questions is possible throughout the test.
          </v-list-item>
        </v-list>
        <v-subheader>Rules and Regulations</v-subheader>
        <v-list>
          <v-list-item>
            1. Any form of cheating or violation of rules can result in a
            permanent ban from future tests.
          </v-list-item>
          <v-list-item>
            2. Do not open other tabs or applications during the test.
          </v-list-item>
          <v-list-item>
            3. Your webcam and microphone may be monitored during the test.
          </v-list-item>
        </v-list>

        <v-subheader>Technical Instructions</v-subheader>
        <v-list>
          <v-list-item>
            1. Make sure your device is fully charged or plugged in.
          </v-list-item>
          <v-list-item>
            2. Use an updated browser for the best experience.
          </v-list-item>
          <v-list-item>
            3. If you face any technical issues, contact support immediately.
          </v-list-item>
        </v-list>

        <div class="text-center mt-4">
          <v-alert type="info" dense class="mb-4" border="left">
            Note: The test will automatically submit if the time ends, or if you
            refresh or navigate away from this page.
          </v-alert>
          <v-alert type="error" border="left">
            Warning: Any cheating violation will result in a permanent ban from
            attempting future tests.
          </v-alert>
        </div>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="success" text @click="attemptCompetiton(testComp)"
          >Proceed</v-btn
        >
        <v-btn color="error" text @click="openTest = false">Cancel</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { QUIZ_COMPETITION_START, BASE_URL } from "@/common/apiEndpoints.js";
import axios from "axios";
import { ALREADY_ATTEMPTED } from "@/common/apiMessageConstant";
import { GET_TOKEN } from "@/store/getters";
import { mapGetters, mapMutations } from "vuex";
import { getAxiosOptions } from "@/common/utility";
import {
  SET_API_ERROR,
  SET_OVERLAY_VALUE,
  SET_PARAMS_VALUE,
} from "@/store/mutations";

export default {
  data() {
    return {
      openTest: false,
      testComp: {},
    };
  },
  computed: {
    ...mapGetters({
      token: `schoolModule/${GET_TOKEN}`,
    }),
  },
  methods: {
    ...mapMutations({
      setOverlayValue: `schoolModule/${SET_OVERLAY_VALUE}`,
      setApiError: `schoolModule/${SET_API_ERROR}`,
      setParams: `schoolModule/${SET_PARAMS_VALUE}`,
    }),
    openTestDialog(comp) {
      this.testComp = comp;
      this.openTest = true;
    },
    attemptCompetiton(comp) {
      const url = QUIZ_COMPETITION_START;
      const payload = {};
      payload.competitionId = comp.quizCompId;
      payload.quizId = comp.quizes[0].quizId;
      var compParams = {};
      compParams.competition = comp;
      compParams.isFinished = false;
      axios
        .post(url, payload, getAxiosOptions(BASE_URL, this.token))
        .then((res) => {
          this.openTest = false;
          this.setParams(compParams);
          this.$router.push({
            name: "QuizCompetition",
            params: { durationTime: comp.duration },
          });
        })
        .catch((error) => {
          error = error.errorMessage;
          this.setOverlayValue(false);
          this.openTest = false;
          this.setApiError(ALREADY_ATTEMPTED);
        });
    },
  },
};
</script>